/* @flow */
type DataLayer = Array<
  | {
      event: "event-to-ga",
      eventCategory:
        | "API Error"
        | "Socket Error"
        | "Insufficient Popup"
        | "tour"
        | "money"
        | "profile"
        | "Trade"
        | "Apk Download",
      eventAction: string,
      eventLabel?: string
    }
  | {
      event: "exception-to-ga",
      exDescription: string,
      exFatal: boolean
    }
>;

const dataLayer = event => {
  if (window.location.host === "test.siamoption.com") {
    if (process.env.REACT_APP_DEPLOY_TARGET === "siamoption") {
      return false;
    }
  }

  const dataLayer: DataLayer = window.dataLayer || [];

  try {
    dataLayer.push(event);
  } catch (error) {
    console.warn("GA error ", error);
  }
};

export default dataLayer;



// WEBPACK FOOTER //
// ./src/components/common/dataLayer.js